import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { enregistrerSW } from './push';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

enregistrerSW();
